export const parseStringBoolean = (stringBoolean, truthyBoolean = 'true') => !!stringBoolean && truthyBoolean.includes(stringBoolean);